import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'

import { updateUserEmail } from 'data/users/actions'
import { getCurrentUser, getUpdateEmailState } from 'data/users/selectors'

import { InputWithLabel, Input } from 'components/Utils/Form'
import Text from 'components/base/Text'
import UpdateStatus from 'components/Utils/UpdateStatus'
import PasswordModal from 'components/Utils/Modal/Password'

class UpdateEmailForm extends Component {
  state = {
    isModalOpen: false,
  }
  static propTypes = {
    updateUserEmail: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    setEmail: PropTypes.func.isRequired,
    setPassword: PropTypes.func.isRequired,
  }

  onUpdateEmail = event => {
    event.preventDefault()
    const { email, password, updateUserEmail } = this.props
    updateUserEmail(email, password)
    this.setState({ isModalOpen: false })
  }

  render() {
    const {
      viewer,
      email,
      password,
      setEmail,
      setPassword,
      updateState,
    } = this.props

    const updateEmailLink = !viewer.get('ssoEnabledAt')
    const provider = viewer.hasOauth && viewer.oauthProvider !== null
    return (
      <div
        className="flexbox-grow margin-right-small"
        style={{ maxWidth: 315 }}
      >
        <div className="padding-bottom-normal">
          <div className="flexbox flexbox-align-center flexbox-space-between">
            <Text.Section htmlFor="accountEmail">
              Email address
              {provider && (
                <span className="font-weight-regular shade-30 font-size-smaller">
                  {' '}
                  (provided by{' '}
                  <span className="capitalize">{viewer.oauthProvider}</span>)
                </span>
              )}
            </Text.Section>
            <PasswordModal
              show={this.state.isModalOpen}
              onConfirm={this.onUpdateEmail}
              onCancel={() => this.setState({ isModalOpen: false })}
              confirmLabel="Confirm"
              cancelLabel="Cancel"
            >
              <div>
                <Text.Subtitle className="text-align-left font-weight-medium">
                  Change your email
                </Text.Subtitle>
                <div className="margin-vertical-large text-align-left">
                  <span className="font-size-normal font-family-system shade-20">
                    You're about to change the email address you use to sign in
                    to Slite. Enter your new email address and your Slite
                    password to confirm this change
                  </span>
                </div>
                <InputWithLabel
                  id="newAccountEmail"
                  type="text"
                  label="New email"
                  className="block width-full text-align-left margin-bottom-large"
                  onChange={setEmail}
                  value={email}
                  placeholder="Enter your email"
                />
                <InputWithLabel
                  id="accountPassword"
                  onChange={setPassword}
                  label="Password"
                  value={password}
                  className="block width-full text-align-left margin-bottom-large"
                  type="password"
                  placeholder="Enter your password"
                />
              </div>
            </PasswordModal>
            {updateEmailLink && (
              <div className="margin-left-large">
                <Text.Action
                  className="margin-left-auto"
                  onClick={() => {
                    this.setState({ isModalOpen: true })
                  }}
                >
                  Edit
                </Text.Action>
              </div>
            )}
          </div>
        </div>

        <div>
          <Input
            id="accountEmail"
            type="text"
            className="block width-full"
            value={viewer.email}
            placeholder="neil-changed@nasa.com"
            disabled={true}
          />
        </div>
        <UpdateStatus updateState={updateState} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const viewer = getCurrentUser(state)
  return {
    viewer,
    updateState: getUpdateEmailState(state),
  }
}

const mapDispatchToProps = {
  updateUserEmail,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('email', 'setEmail', ({ viewer }) => viewer.email),
  withState('password', 'setPassword', ''),
  withHandlers({
    setEmail: ({ setEmail }) => event => setEmail(event.target.value),
    setPassword: ({ setPassword }) => event => setPassword(event.target.value),
  })
)(UpdateEmailForm)
